import SecLogo from './SecLogo'
import SecLinks from './SecLinks'

function NavbarLast(){

  return(
      <header style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 100, background: 'transparent', border: 'none', padding: '16px 0' }}>
        <div className="container-fluid" style={{ maxWidth: '1120px', margin: '0 auto', padding: '0 20px', width: '100%' }}>
          <SecLogo />
          <SecLinks />
        </div>
      </header>
  )
}

export default NavbarLast
